export const useSubscription = () => {
    const hasActiveSubscription = false;
    return {
        hasActiveSubscription,
    };
};
